import { createSelector } from 'reselect';

const getPaymentData = (state) => state.paymentData;

const getFiscalInfo = createSelector(
  getPaymentData,
  (paymentDataState) => paymentDataState.fiscal_info
);

const getPaymentMethod = createSelector(
  getPaymentData,
  (paymentDataState) => paymentDataState.payment_method
);

export default {
  getPaymentData,
  getFiscalInfo,
  getPaymentMethod,
};
